
import Chartist from 'chartist';


function projectY(chartRect, bounds, value) {
  return chartRect.y1 -
    (chartRect.height() * (value - bounds.min) / (bounds.range));
  // return chartRect.y1 -
  //   (chartRect.height() * (value - bounds.min) / (bounds.range + bounds.step));
}

function ctTargetLine(options) {
  return function ctTargetLine(chart) {
    var defaultOptions = {
      // labelClass: 'ct-label',
      // labelOffset: {
      //   x: 0,
      //   y: -10
      // },
      // textAnchor: 'middle'
    };

    options = Chartist.extend({}, defaultOptions, options);

    if (chart instanceof Chartist.Bar) {
      // chart.on('draw', function(data) {
      //   console.log(data);
      //   if(data.type === 'bar') {
      //     data.group.elem('text', {
      //       x: data.x + options.labelOffset.x,
      //       y: data.y + options.labelOffset.y,
      //       style: 'text-anchor: ' + options.textAnchor
      //     }, options.labelClass).text(data.value.y);
      //   }
      // });

      chart.on('created', function (context) {
        var targetLineY = projectY(context.chartRect, context.bounds, context.options.targetLine.value);

        context.svg.elem('line', {
          x1: context.chartRect.x1,
          x2: context.chartRect.x2,
          y1: targetLineY,
          y2: targetLineY
        }, context.options.targetLine.class);
      });
    }
  }
}

export default ctTargetLine;